import React, { useEffect, useState } from 'react';
import { Zap } from 'lucide-react';
export function UrgencyBar() {
  const [spots, setSpots] = useState(347);
  // Optional: simulate spots decreasing slowly for added urgency
  useEffect(() => {
    const interval = setInterval(() => {
      setSpots(prev => prev > 12 ? prev - 1 : prev);
    }, 45000);
    return () => clearInterval(interval);
  }, []);
  return <div className="fixed top-0 left-0 right-0 z-50 bg-brand-orange text-black font-bold text-sm md:text-base py-2 px-4 shadow-lg" data-id="element-187">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-center md:justify-between gap-1 md:gap-4 text-center" data-id="element-188">
        <div className="flex items-center gap-2" data-id="element-189">
          <Zap className="w-4 h-4 md:w-5 md:h-5 fill-black" data-id="element-190" />
          <span className="uppercase tracking-wide" data-id="element-191">
            Alerta de Lanzamiento Beta: Acceso al Protocolo Alpha por solo $6.36
            (Precio normal $47). Solo para los primeros 500 hombres.
          </span>
        </div>
        <div className="bg-black text-brand-orange px-3 py-1 rounded-sm text-xs md:text-sm whitespace-nowrap animate-pulse" data-id="element-192">
          {spots} / 500 cupos restantes
        </div>
      </div>
    </div>;
}